import React, { Fragment, useState } from 'react';
import { ClarovideoLogoV2 } from 'components/onboarding/components/ClarovideoLogoV2';
import { OnboardingButton } from 'components/onboarding/components/DefaultButton';
import { TelmexButton } from 'components/onboarding/components/TelmexButton';
import { useMetrics } from 'hooks/metrics/useMetrics';
import { OnboardingLoading } from 'components/onboarding/components/OnboardingLoading';
import { useSearchParams } from 'react-router-dom';
import TelmexIframeModal from 'components/TelmexIframeModal';
import useExternalTelmexLogin from 'components/TelmexIframeModal/utils/useExternalLoginTelmex';

export const LandingMainMetadata = ({
  isMobile,
  texts,
  onRedirect,
  showTelmex = false,
  setUserhash,
  setUserData,
}) => {
  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();
  const [searchParams] = useSearchParams();
  const isAppLanding = searchParams.get('source') === 'app';

  const onOtpAndHandoffFinish = async loginResp => {
    //LOGIN PARA APPS MOVILES
    let userhash = loginResp?.data?.session_userhash;
    if (userhash) {
      setUserData(loginResp?.data)
      return setUserhash(userhash)
    };
  };

  const {
    isOpen,
    setIsOpen,
    requestError,
    setRequestError,
    handleExternalLogin,
    handleOtpAndHandoffFinish,
    showLoaderRequest,
  } = useExternalTelmexLogin(onOtpAndHandoffFinish);

  return (
    <>
      <OnboardingLoading show={showLoaderRequest} />
      {isOpen && (
        <TelmexIframeModal
          onSuccess={
            isAppLanding ? handleOtpAndHandoffFinish : handleExternalLogin
          }
          isOpen={isOpen}
          requestError={requestError}
          onClose={() => { setRequestError(false); setIsOpen(false)}}
          moduleName='landing'
          isLanding={true}
        />
      )}
      <div className="LandingPageV2__Main__Metadata">
        {!isMobile && <ClarovideoLogoV2 isLanding={true} />}

        <h2 className="LandingPageV2__Main__Metadata__Title">
          {texts.TITLE_PART_1}
          <br />
          {texts.TITLE_PART_2}
        </h2>

        <span className="LandingPageV2__Main__Metadata__TelmexProvider">
          {showTelmex && (
            <Fragment>
              {texts.TELMEX_PART_1}
              <br />
              {texts.TELMEX_PART_2} <b>{texts.TELMEX_PART_3}</b>
            </Fragment>
          )}
        </span>

        <div className="LandingPageV2__Main__Metadata__TelmexButton">
          {showTelmex && (
            <TelmexButton
              assetKey='Landing_PaginaPrincipal_Boton_Logo_Telmex'
              styles={{ minWidth: '100%', width: "100%"  }}
              onClick={() => {
                const event = buildMetricsEvent('landing', {
                  content_section: 'landing',
                  interaction_type: 'telmex',
                  modulo_name: 'Regístrate con tu proveedor y activa tus beneficios SIN COSTO:',
                  method: 'mi telmex',
                });

                sendMetricsEvent(event);
                setIsOpen(true);
              }}
              moduleName="landing"
            />
          )}
        </div>

        <span className="LandingPageV2__Main__Metadata__ThirdProvider">
          {texts.THIRD_PROVIDER}
        </span>

        <OnboardingButton
          className="LandingPageV2__Main__Metadata__ThirdButton"
          variant={isMobile ? 'secondary' : 'primary'}
          size="large"
          textContent={texts.REGISTER_WITH_EMAIL}
          onClick={() => onRedirect('register')}
          
        />
      </div>
    </>
  );
};
